import _objectSpread from "/Users/developer05/project/wiseberry_sass_frontEnd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/Users/developer05/project/wiseberry_sass_frontEnd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/developer05/project/wiseberry_sass_frontEnd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import epoch from '../lib/epoch.js';
import isObject from '../lib/is_object.js';
import secs from '../lib/secs.js';
export var ProduceJWT = /*#__PURE__*/function () {
  function ProduceJWT(payload) {
    _classCallCheck(this, ProduceJWT);
    if (!isObject(payload)) {
      throw new TypeError('JWT Claims Set MUST be an object');
    }
    this._payload = payload;
  }
  _createClass(ProduceJWT, [{
    key: "setIssuer",
    value: function setIssuer(issuer) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        iss: issuer
      });
      return this;
    }
  }, {
    key: "setSubject",
    value: function setSubject(subject) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        sub: subject
      });
      return this;
    }
  }, {
    key: "setAudience",
    value: function setAudience(audience) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        aud: audience
      });
      return this;
    }
  }, {
    key: "setJti",
    value: function setJti(jwtId) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        jti: jwtId
      });
      return this;
    }
  }, {
    key: "setNotBefore",
    value: function setNotBefore(input) {
      if (typeof input === 'number') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: input
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: epoch(new Date()) + secs(input)
        });
      }
      return this;
    }
  }, {
    key: "setExpirationTime",
    value: function setExpirationTime(input) {
      if (typeof input === 'number') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: input
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: epoch(new Date()) + secs(input)
        });
      }
      return this;
    }
  }, {
    key: "setIssuedAt",
    value: function setIssuedAt(input) {
      if (typeof input === 'undefined') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: epoch(new Date())
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: input
        });
      }
      return this;
    }
  }]);
  return ProduceJWT;
}();